var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('P',[_vm._v("暂无")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }